// @ts-nocheck
import * as Types from '../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
export type SummaryUtils_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, isEnabled: boolean, subStepNumber?: number | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isSpecLevel: boolean, isInteriorScheme: boolean } }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } }>, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, includedByRoot?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined };

export const SummaryUtils_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment SummaryUtils_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  step
  isEnabled
  subStepNumber
  group {
    id
    name
    group {
      id
      type {
        id
        isSpecLevel
        isInteriorScheme
      }
    }
    location {
      id
      name
    }
  }
  options {
    id
    totalPriceInCents
    option {
      id
      name
      code
    }
  }
  selectedOption {
    id
    totalPriceInCents
    includedByRoot {
      id
      option {
        id
        name
        code
      }
    }
    option {
      id
      name
      code
    }
  }
}
    `;